import { AttachingMethod, Attachment, AttachmentType } from '@wix/ambassador-funnel-chatbot-v1-session/types';

import {
  AttachingMethod as AttachingMethodClient,
  Attachment as AttachmentClient,
  AttachmentType as AttachmentTypeClient,
} from '../../../types';
import { isWebUrl } from '../../util/isWebUrl';

const attachmentMethodMapper: Record<AttachingMethodClient, AttachingMethod> = {
  [AttachingMethodClient.Button]: AttachingMethod.BUTTON,
  [AttachingMethodClient.Drop]: AttachingMethod.DROP,
  [AttachingMethodClient.Paste]: AttachingMethod.PASTE,
};

export const attachmentMapper = (attachment: AttachmentClient): Attachment => {
  const { name, url, width, height, size, attachingMethod, mimeType, filePath } = attachment;
  const attachmentBase = {
    name,
    url,
    width,
    height,
    size,
    attachingMethod: attachmentMethodMapper[attachingMethod],
    ...(mimeType ? { mimeType } : {}),
    // filePath is proto field 12 (file_path); ambassador types lag behind the proto, hence the cast
    ...(filePath ? { filePath } : {}),
  };

  if (attachment.type === AttachmentTypeClient.Video) {
    const { iconUrl, duration, format } = attachment;
    return {
      ...attachmentBase,
      // Proto field `icon_url` is annotated `(.wix.api.format) = WEB_URL` and rejects non-http(s) values
      // (data:, blob:, …). Such values are valid client-only preview sources but must not cross the wire.
      ...(isWebUrl(iconUrl) ? { iconUrl } : {}),
      duration,
      format,
      type: AttachmentType.VIDEO,
    } as Attachment;
  } else {
    return { ...attachmentBase, type: AttachmentType.IMAGE } as Attachment;
  }
};
